<template>
  <div style="position: relative;">
    <!-- <h1 class="title">{{ $t("survey.text") }}</h1> -->

    <div class=" ">
      <right-panel class="float-right" id="sidebar-add-survey" width="600px" @hidden="rightPanelClosed">
        <div class="pl-5 pr-5">
          <OrganizationSurveyTemplateAddLibraryForm :product="currentProduct" />
        </div>
      </right-panel>
      <right-panel class="float-right" id="sidebar-add-question-set" width="1100px" @hidden="rightPanelClosed">
        <div class="pl-5 pr-5">
          <OrganizationQuestionSetAddLibraryForm :product="currentProduct || 'PLATFORM'" />
        </div>
      </right-panel>

      <nav class="tab-menu">
        <div :class="{ active: activeTab === 'admin' }" @click="activeTab = 'admin'">
          {{ $t("survey.as-admin") }}
        </div>
        <div v-if="hasOrganizationQuestionSetViewPermission" :class="{ active: activeTab === 'organization' }" @click="activeTab = 'organization'">
          {{ $t("survey.organization") }}
        </div>
        <!-- <div :class="{ active: activeTab === 'account' }" @click="activeTab = 'account'">{{ $t("survey.account") }}</div> -->
      </nav>

      <div v-if="activeTab == 'admin'" class="mt-4">
        <div v-if="hasOrganizationQuestionSetViewPermission" @click="$root.$emit('bv::toggle::collapse', `sidebar-add-survey`)">
          <div class="d-flex justify-content-end" style="margin-bottom: 1.70rem;">
            <div class="new-task-text mt-2">{{ $t("survey-template.new") }}</div>
            <div class="plus-button" style="margin-right: 1.56rem;"></div>
          </div>
        </div>
        <div class="qcontainer" v-if="pagination">
          <div class="qcard" v-for="item in pagination.docs" :key="item._id">
            <div class="qcard--header">
              <div class="d-flex hand" @click="redirectSurveyPage(item)">
                <div class="qtitle hand">{{ item.name | translate }}</div>
                <div>
                  <i v-if="item.hasActiveSurvey" v-b-tooltip.hover :title="$t('survey.active-survey-exists')" class="bx bxs-circle text-success font-size-20"></i>
                  <i v-if="!item.hasActiveSurvey" v-b-tooltip.hover :title="$t('survey.active-survey-not-exists')" class="bx bxs-circle text-danger font-size-20"></i>
                </div>
                <!-- <div class="qtitle2">{{ item.products.join(", ") }}</div> -->
              </div>
              <div class="d-flex align-items-center qactions">
                <i class="iconoir-trash" @click="deleteById(item)" style="font-size: 1.5rem; color: #99A1B7;"></i>
              </div>
            </div>
            <div v-if="item.hasActiveSurvey">
              <p>
                <strong>{{ $t("survey.approved-participants") }}</strong> {{ item.approvedParticipants }}
              </p>
              <p>
                <strong>{{ $t("survey.total-participants") }}</strong> {{ item.approvedParticipants }}
              </p>
            </div>
            <div class="mb-2">
              <SurveyPeriodicalSelect @onSave="periodEdited($event, item)" :survey="item"></SurveyPeriodicalSelect>
            </div>
            <div class="qs-title mb-2">{{ $t("common.description") }}</div>
            <div class="qs-description">
              {{ item.description | translate }}
            </div>

            <div class="qs-title mt-2">{{ $t("survey.admin") }}</div>
            <div class="assignee-wrapper mt-2">
              <organization-member-select :selected="item.admin.account" @onSelect="onAssigneeChanged($event, item)" style="min-width: 250px;" />

              <i class="iconoir-info-circle" v-b-tooltip.hover.top="{ variant: 'main' }" :title="$t('survey.admin')" style="font-size: 1.125rem; color: #C3CCE7; "></i>
            </div>
            <hr />
          </div>
        </div>
        <empty v-if="!pagination || pagination.docs.length == 0">
          <h5 class="text-center">
            {{ $t("common.no-data") }}
          </h5>
        </empty>
        <div v-if="pagination" class="row mt-4">
          <div class="col">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
            </ul>
          </div>
        </div>
      </div>

      <div v-if="activeTab == 'organization' && hasOrganizationQuestionSetViewPermission" class="mt-4">
        <div @click="$root.$emit('bv::toggle::collapse', `sidebar-add-survey`)">
          <div class="d-flex justify-content-end" style="margin-bottom: 1.70rem;">
            <div class="new-task-text mt-2">{{ $t("survey-template.new") }}</div>
            <div class="plus-button" style="margin-right: 1.56rem;"></div>
          </div>
        </div>
        <div class="qcontainer" v-if="pagination">
          <div class="qcard" v-for="item in pagination.docs" :key="item._id">
            <div class="qcard--header">
              <div class="d-flex hand" @click="redirectSurveyPage(item)">
                <div class="qtitle hand">{{ item.name | translate }}</div>
                <div class="qtitle2">{{ item.products.join(", ") }}</div>
              </div>
              <div class="d-flex align-items-center qactions">
                <i class="iconoir-trash" @click="deleteById(item)" style="font-size: 1.5rem; color: #99A1B7;"></i>
              </div>
            </div>
            <div>
              <SurveyPeriodicalSelect @onSave="periodEdited($event, item)" :survey="item"></SurveyPeriodicalSelect>
            </div>
            <div class="qs-title">{{ $t("common.description") }}</div>
            <div class="qs-description">
              {{ item.description | translate }}
            </div>

            <div v-if="activeTab == 'admin'">
              <div class="qs-title mt-2">{{ $t("survey.admin") }}</div>
              <div class="assignee-wrapper mt-2">
                <organization-member-select :selected="item.admin.account" @onSelect="onAssigneeChanged($event, item)" style="min-width: 250px;" />

                <i class="iconoir-info-circle" v-b-tooltip.hover.top="{ variant: 'main' }" :title="$t('survey.admin')" style="font-size: 1.125rem; color: #C3CCE7; "></i>
              </div>
            </div>
            <hr />
          </div>
        </div>
        <empty v-if="!pagination || pagination.docs.length == 0">
          <h5 class="text-center">
            {{ $t("common.no-data") }}
          </h5>
        </empty>
        <div v-if="pagination" class="row mt-4">
          <div class="col">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination v-model="request.options.page" :total-rows="pagination.totalDocs" :per-page="pagination.limit" limit="10" size="sm"></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalSelect from "@c/modal-select";
import OrganizationMemberSelect from "@cc/organization-member-select";
import OrganizationQuestionSetAddLibraryForm from "../question/component/organization-question-set-add-library-form";
import OrganizationSurveyTemplateAddLibraryForm from "./component/organization-survey-template-add-library-form.vue";
import SurveyPeriodicalSelect from "./component/survey-periodical-select";

export default {
  components: { ModalSelect, OrganizationQuestionSetAddLibraryForm, OrganizationSurveyTemplateAddLibraryForm, OrganizationMemberSelect, SurveyPeriodicalSelect },
  data() {
    return {
      request: {
        options: { page: 1, limit: 10, sort: { no: "asc" } },
        query: { products: { value: this.currentProduct || "PLATFORM", isObject: true } },
      },
      myQuestionSetsRequest: {
        options: { page: 1, limit: 10, sort: { no: "asc" } },
        query: { products: { value: this.currentProduct || "PLATFORM", isObject: true } },
      },
    };
  },

  computed: {
    activeTab: {
      get() {
        return this.$store.getters["organizationSurvey/activeTab"];
      },
      set(v) {
        this.$store.commit("organizationSurvey/activeTab", v);
      },
    },
    hasOrganizationQuestionSetViewPermission() {
      if (
        this.currentAccountHasPermissions([
          "ORGANIZATION_ADMIN",
          "ORGANIZATION_GDPR_PRODUCT_ADMIN",
          "ORGANIZATION_KVKK_PRODUCT_ADMIN",
          "ORGANIZATION_DDO_PRODUCT_ADMIN",
          "ORGANIZATION_BGYS_PRODUCT_ADMIN",
          "ORGANIZATION_INFORMATION_TECHNOLOGY_ADMIN",
          "ORGANIZATION_RISK_ADMIN",
          "ORGANIZATION_LEGAL_ADMIN",
        ])
      ) {
        return true;
      }

      return false;
    },

    pagination() {
      return this.$store.getters["organizationSurveyTemplate/pagination"];
    },

    isLoading() {
      return this.$store.getters["organizationSurveyTemplate/isLoading"];
    },
    myQuestionSetsPagination() {
      return this.$store.getters["organizationQuestionSet/myQuestionSetsPagination"];
    },
    myQuestionSets() {
      return this.myQuestionSetsPagination?.docs ?? [];
    },
    isMyQuestionSetsLoading() {
      return this.$store.getters["organizationQuestionSet/isMyQuestionSetsLoading"];
    },
  },

  watch: {
    myQuestionSetsRequest: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginateMyQuestionSets(), "my");
      },
    },
    activeTab(v) {
      this.paginate();
      if (v == "account") {
        return this.paginateMyQuestionSets();
      }
    },
    request: {
      deep: true,
      immediate: true,
      handler() {
        this.debounce(() => this.paginate());
      },
    },
  },

  methods: {
    async paginateMyQuestionSets() {
      let payload = {
        ...this.myQuestionSetsRequest,
        query: {
          ...this.myQuestionSetsRequest.query,
          organization: { value: this.currentOrganization?._id, isObject: true },
          products: { value: this.currentProduct || "PLATFORM", isObject: true },
          isSurvey: { value: true, isObject: true },
          // status: { value: { $ne: "NONE" }, isObject: true },
        },
      };
      if (this.scope === "ACCOUNT") {
        delete payload.query.organization;
      }

      await this.$store.dispatch("organizationQuestionSet/fetchCurrentUserAssignedQuestionSet", payload);
    },
    answerQuestionSet(item) {
      this.$router.push(`/${this.currentProduct ? this.currentProduct.toLowerCase() : "organization"}/question-set/answering/${item._id}`);
    },

    redirectSurveyPage(item) {
      this.$store.commit("organizationSurveyTemplate/selectedEntity", item);
      this.$router.push(`/${this.currentProduct ? this.currentProduct.toLowerCase() : "organization"}/survey/template/${item._id}`);
    },

    async paginate() {
      let query = { products: { value: this.currentProduct || "PLATFORM", isObject: true } };

      if (this.activeTab == "admin") {
        query = { ...query, admin: { value: this.currentAccount._id, isObject: true } };
      } else if (this.activeTab == "account") {
        query = { ...query, assignee: { value: this.currentAccount._id, isObject: true } };
      }

      await this.$store.dispatch("organizationSurveyTemplate/paginate", {
        ...this.request,
        query,
      });
    },

    periodEdited() {
      //TODO
    },
    async onAssigneeChanged(account, surveyTemplate) {
      if (account?._id == surveyTemplate?._id) {
        return;
      }
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }

      try {
        await this.$store.dispatch("organizationSurveyTemplate/updateAdmin", { account, surveyTemplate });

        this.$toast.success(this.$t("common.success"));
        this.paginate();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async onQuestionSetSelected(libraryItem) {
      if (!libraryItem) {
        return;
      }

      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("organizationSurveyTemplate/addFromLibrary", {
          libraryItem,
        });
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async deleteById(item) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`organizationSurveyTemplate/delete`, item._id);
        this.rightPanelClosed();

        this.$toast.success("'" + this.$options.filters.translate(item.name) + "' " + this.$t("common.delete-successful"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    rightPanelClosed() {
      this.paginate();
      this.fetchLibraryItems();
    },
    fetchLibraryItems() {
      this.$store.dispatch(`workspaceQuestion/paginate`, this.libraryRequest);
    },

    //
  },
};
</script>

<style lang="scss" scoped>
@import "./question-set";
</style>
